/* lua.js generated code 0.3.0 */

var Button = ccui.Button
Button.prototype.onClicked = function (callback) {
    var self = this
    self.addClickEventListener(callback)
    return self
}
Button.prototype.setDisabled = function (value) {
    var self = this
    self.setBright(!value)
    self.setTouchEnabled(!value)
}
Button.prototype.onTouchDown = function (callback) {
    var self = this
    self.addTouchEventListener(callback)
    return self
}
